export default __webpack_public_path__ + "static/media/nerd.40e73036.png";